function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import classnames from 'classnames';
import injectStyles from "../jss";
import React from 'react';
import styles from "./Spinner.jss";
import { Range } from 'immutable';
export var Spinner = /*#__PURE__*/function (_React$Component) {
  _inherits(Spinner, _React$Component);

  function Spinner() {
    _classCallCheck(this, Spinner);

    return _possibleConstructorReturn(this, _getPrototypeOf(Spinner).apply(this, arguments));
  }

  _createClass(Spinner, [{
    key: "renderCircle",
    value: function renderCircle(step) {
      var _this$props = this.props,
          classes = _this$props.classes,
          color = _this$props.color,
          stepCount = _this$props.stepCount;
      var animationDelay = "".concat((step * (1.3 / stepCount) - 1.1).toFixed(2), "s");
      var transform = "rotate(".concat(step * 360 / stepCount, "deg)");
      return React.createElement("div", {
        key: step,
        className: classnames('spinnerStep', classes.circle),
        style: {
          transform: transform
        }
      }, React.createElement("div", {
        className: classes.circleBefore,
        style: {
          animationDelay: animationDelay,
          backgroundColor: color
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          size = _this$props2.size,
          stepCount = _this$props2.stepCount;
      var spinner = Range(0, stepCount).toArray().map(this.renderCircle, this);
      return React.createElement("div", {
        style: {
          width: size,
          height: size
        },
        className: classes.wrapper
      }, spinner);
    }
  }]);

  return Spinner;
}(React.Component);

_defineProperty(Spinner, "styleRoot", 'Spinner');

_defineProperty(Spinner, "defaultProps", {
  color: 'white',
  size: 22,
  stepCount: 12
});

export default injectStyles(styles)(Spinner);